import {
  Button,
  Card,
  Col,
  Empty,
  Form,
  Row,
  Space,
  Spin,
  Typography
} from "antd";
import {GlobalCard} from "../Components/GlobalCard";
import {useEffect, useState} from "react";
import useFetch from "../../hooks/useFetch";
import {FetchApiInterface} from "../../interfaces/FetchApi.interface";
import {AxiosResponse} from "axios";
import {ResponseInterface} from "../../interfaces/Response.interface";
import {ArrowLeftOutlined, FilterOutlined, DeleteOutlined, SyncOutlined} from "@ant-design/icons";
import TableCustom from "../Components/TableCustom";
import useProcesDataTable from "../../hooks/useProcesDataTable";
import {TableDataInterface} from "../../interfaces/TableData.interface";
import {dataInitial} from "../../config/dataConfig";
import useBreakpoint from "antd/es/grid/hooks/useBreakpoint";
import useMessageUser from "../../hooks/useMessageUser";
import {useTranslation} from "react-i18next";
import Search from "antd/lib/input/Search";
import DpaSelected from "../Components/DpaSelected";
import {useNavigate} from "react-router-dom";
import DoubleScDetail from "../Components/Home/DoubleScDetail";
import {hasAccess} from "../../utils";

const dateFormat = 'YYYY-MM-DD';

const dataConfig = [
  {
    key: 'dafId',
    title: 'ID',
    hiddenToColumn: true,
  },
  {
    key: 'famName',
    title: 'scTableName'
  },
  {
    key: 'scNumber',
    title: 'scNumber'
  },
  {
    key: 'pafWorker',
    title: 'pafWorker'
  },
  {
    key: 'dpa.dpaName',
    title: 'dpa'
  },
  {
    key: 'famBornYear',
    title: 'famBornYear'
  },
];

const actions = {
  list: {
    key: "list",
    name: "SC's"
  },
  create: {
    key: "create",
    name: "Crear idioma",
    breadcrumb: [
      {
        children: "SC's",
        href: '/home',
      },
      {
        children: "Crear nuevo SC"
      }
    ]
  },
  detail: {
    key: "detail",
    name: "Sc detail",
    breadcrumb: [
      {
        children: "SC's",
        href: '/home',
      },
      {
        children: "SC detail"
      }
    ]
  },
}

function PossibleAffiliate() {

  const { md, lg } = useBreakpoint();
  const { t } = useTranslation();
  const [form] = Form.useForm();

  const [dataRegisters, setDataRegister] = useState<TableDataInterface>(dataInitial);
  const [action, setAction] = useState<any>( actions.list);
  const [expanded, setExpanded] = useState<boolean>( true);
  const [loadZip, setLoadZip] = useState<boolean>( false);
  const [scId, setScId] = useState<number>( 0);
  const [homeFilter, setHomeFilter] = useState<any>( { statusRegister: true });
  const { fetchApi, downloadFile, loading } = useFetch();
  const { processData } = useProcesDataTable();
  const { showMessage }  = useMessageUser();
  // filtros
  const [selectPicker, setSelectPicker] = useState('selected');
  const [filterApply, setFilterApply] = useState<any>({});
  const [filters, setFilters] = useState<any>({});
  const navigate = useNavigate();

  useEffect(() => {
    // solo el rol de ROLE_SYSADMIN no tiene acceso a esta pantalla
    if (hasAccess(['ROLE_SYSADMIN'])) {
      return;
    } else {
      navigate('/users');
    }
  }, []);

  useEffect(() => {
    if (lg) {
      setExpanded(true);
    } else {
      setExpanded(false);
    }
  }, [lg]);


  useEffect(() => {
    if (localStorage.getItem('filter-pa')) {
      const filters = JSON.parse(localStorage.getItem('filter-pa') as string);
      setHomeFilter(filters);
      setTimeout(() => {
        processFilter();
      }, 500);
    } else {
      clearFilter();
    }
  }, []);

  const getRegisters = (data: any = {}, page = 0) => {
    setFilters(data);
    const dataSend: FetchApiInterface = {
      url: `/members/posible_afiliados?page=${page}`,
      data
    }
    fetchApi(dataSend ).then(
      ({ data }: AxiosResponse<ResponseInterface>) => {
        if (data.status === 'success') {
          const dataResponse = data?.data;
          const dataProcess = processData(dataResponse?.content || [], dataConfig);
          setDataRegister({
            ...dataProcess,
            paginate: {
              size: dataResponse.size,
              totalElements: dataResponse.totalElements,
              totalPages: dataResponse.totalElements,
              pageNumber: dataResponse?.pageable?.pageNumber + 1
            }
          });
        } else {
          showMessage(data?.message, 'info');
        }
      }
    ).catch((reason: any) => {
      showMessage(reason?.message, 'error');
    });
  }

  const changeAction = (option: string) => {
    // @ts-ignore
    const actionItem = actions[option];
    setAction(actionItem);
  }

  const pageChange = (page: number) => {
    processFilter(page);
  }

  // Filtros
  const checkClearText = () => {
    const search  = form.getFieldValue('search');
    if (!Boolean(search)) {
      processFilter();
    }
  }

  const clearFilter = () => {
    localStorage.removeItem('filter-pa');
    form.resetFields();
    setHomeFilter({});
    setFilterApply({});
    setSelectPicker('selected');
    processFilter();
  }
  const selectDate = (dates: any) => {
    const datesFormat = {
      value1: dates[0].format(dateFormat),
      value2: dates[1].format(dateFormat),
    };
    form.setFieldValue('rangeSync', datesFormat);
  }

  const existKey = (values: any): boolean => {
    if (values?.region || values?.country || values?.pu || values?.level4 || values?.genre || values?.rangeAge) return true;

    return !!values?.rangeSync;
  }

  useEffect(() => {
    processFilter();
  }, [filterApply]);

  const processFilter = (page = 0) => {
    const values = form.getFieldsValue();
    console.log(values);
    if (existKey(values)) {
      localStorage.setItem('filter-pa', JSON.stringify(values));
    }
    const dataFilter: any = {};

    if (Boolean(values?.search)) {
      dataFilter.search = values.search;
    }
    if (Boolean(values?.genre)) {
      dataFilter.genre = values.genre;
    }
    if (values?.rangeAge?.[1] > 0) {
      dataFilter.rangeAge = {
        value1: values.rangeAge[0],
        value2: values.rangeAge[1],
      }
    }
    if (values?.rangeSync?.value1 && values?.rangeSync?.value2 ) {
      dataFilter.rangeSync = values.rangeSync;
    }

    if (filterApply?.dpas) {
      dataFilter.dpas = filterApply?.dpas || [];
    } else if (values?.dpa) {
      dataFilter.dpas = [
        {
          dpaId: filterApply.dpa,
        }
      ] || [];
    }
    getRegisters({
     ...dataFilter,
     statusRegister: true,
    }, page);
  }

  const downloadExcel = () => {
    setLoadZip(true);
    downloadFile('/members/posible_afiliados/export', filters).then(
      (response: any) => {
        const dateNow = new Date().toISOString();
        if (response.status === 200) {
          // Crear un objeto URL temporal que apunte al Blob
          const url = URL.createObjectURL(response.data);

          // Crear un enlace en la página que apunte al URL
          const link = document.createElement('a');
          link.href = url;
          link.download = `${dateNow}_posibles_afiliables.xlsx`;
          document.body.appendChild(link);

          // Hacer clic en el enlace para descargar el archivo
          link.click();

          // Liberar el objeto URL temporal
          URL.revokeObjectURL(url);
        } else {
          showMessage('ExceptionNoReport', 'info');
        }
      }
    ).catch(reason => {
      showMessage(reason?.message, 'error');
    }).finally(() => {
      setLoadZip(false);
    });
  }

  return(
    <Row>
      <Col span={24}>
        <Row justify='center' gutter={[20, 20]}>
          {
            (action.key === "list") && (
              <Col span={24} lg={6} xxl={5} className={ (lg) ? 'content-layout' : '' }>
                <Card className="h-100">
                  {
                    (!lg) && (
                      <Row justify="end">
                        <Col>
                          <Button icon={<FilterOutlined />} type='primary' ghost onClick={() => setExpanded(!expanded)}/>
                        </Col>
                      </Row>
                    )
                  }
                  {
                    (expanded) && (
                      <Form
                        form={form}
                        name="filterHomeForm"
                        autoComplete="off"
                        layout='vertical'
                        initialValues={homeFilter}
                      >
                        <Row>

                          <Col span={24}>
                            <Typography.Title level={4}>{ t('scSearchPossibleAffiliate') }</Typography.Title>
                            <Form.Item
                              name="search"
                            >
                              <Search allowClear placeholder={t('scSearchPlaceholderPossibleAffiliate')} onSearch={() => processFilter()} onChange={checkClearText}/>
                            </Form.Item>
                          </Col>

                          <Col span={24}>
                            <Row justify='space-between' align='middle'>
                              <Col>
                                <Typography.Title level={4}>{ t('scFilter') }</Typography.Title>
                              </Col>
                              <Col>
                                <Button size='small' type='link' icon={<DeleteOutlined />} onClick={clearFilter}>
                                  <Typography.Text underline>
                                    { t('scCleanFilter') }
                                  </Typography.Text>
                                </Button>
                              </Col>
                            </Row>
                          </Col>

                          <Col span={24} md={12} lg={24}>
                            <DpaSelected form={form} setFilterApply={setFilterApply} filterApply={filterApply} />
                          </Col>

                        </Row>
                      </Form>
                    )
                  }
                </Card>
              </Col>
            )
          }
          <Col span={23} lg={18} xxl={19} className='py-2' style={{ paddingRight: (lg) ? '30px' : '' }}>
            <GlobalCard breadcrumb={action?.breadcrumb}>
              <Row gutter={[0, 20]} justify="space-between" className='mb-2'>
                <Col flex="auto">
                  <Typography.Title level={4}>{t('titleListPossibleAffiliate')}</Typography.Title>
                </Col>
                <Col>
                  {
                    (action.key === "list") ? (
                      <Space>
                        {
                          (hasAccess(['ROLE_GUEST', 'ROLE_SYSADMIN'])) && (
                            <Button loading={loadZip} size="large" type="primary" className="btn-border-radius" onClick={downloadExcel}>
                              {t('btnDownloadExcel')}
                            </Button>
                          )
                        }
                        <Button size="large" type="primary" className="btn-border-radius" onClick={() => processFilter()}>
                          <SyncOutlined />
                        </Button>
                      </Space>
                    ) : (
                      <Button size="large" type="dashed" danger className="btn-border-radius" onClick={() => changeAction('list')}>
                        <ArrowLeftOutlined />{ (!md)? null : ` ${t('return')}` }
                      </Button>
                    )
                  }
                </Col>
                <Col span={24}>
                  {
                    (action.key === "list") && (
                      <Row gutter={[20, 20]}>
                        <Col span={24}>
                          <Typography.Title level={5}>
                            {t('scTableResult')} ({ dataRegisters.paginate.totalElements })
                          </Typography.Title>
                        </Col>
                        {
                          (dataRegisters.dataSource.length > 0) ? (
                            <Col span={24}>
                              <Spin spinning={loading}>
                                <TableCustom dataTable={dataRegisters} getRegisters={getRegisters} onPageChange={pageChange} addActions={false} />
                              </Spin>
                            </Col>
                          ) : (
                            <Col span={24}>
                              <Empty/>
                            </Col>
                          )
                        }

                      </Row>
                    )
                  }
                  {
                    (action.key === "detail") && (
                      <DoubleScDetail scId={scId} />
                    )
                  }
                </Col>
              </Row>
            </GlobalCard>
          </Col>
        </Row>
      </Col>
    </Row>
  );
}

export default PossibleAffiliate;
